import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Archive from './pages/Archive';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/arsiv" element={<Archive />} />
          </Routes>
        </main>
        <footer className="footer">
          <p>© 2026 Hüseyin Zeray. Tüm hakları saklıdır.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;

